/* eslint-disable */
// @ts-nocheck

import { Link } from "gatsby"
import React, { useContext, useEffect, useMemo, useRef, useState } from "react"
import { FaSearch, FaShoppingBasket, FaUserCircle } from "react-icons/fa"
import { AiOutlineClose } from "react-icons/ai"
import { StoreContext } from "../../context/StoreContext"
import WrittenLogoMark from "../Icons/WrittenLogoMark"
import SelectedDropDownItem from "./selectedDropDownItem"
import { navigate } from "gatsby"
import { useLocation } from "@reach/router"
import useCheckout from "../../hooks/useCheckout"

const NavBarV2 = ({
  isCartOpen,
  setIsCartOpen,
  story,
  onMenuClick,
  selectedItem,
  setSelectedItem,
}: any) => {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false)
  const location = useLocation()

  const { setAddToCartSidebarTypeFunction, openAddToCartSidebar } =
    useContext(StoreContext)

  const [searchValue, setSearchValue] = useState("")
  const sub_nav_bar_shop = story?.content?.sub_nav_bar_shop
  const content = useMemo(() => {
    if (selectedItem === -1) return null
    const shopAll = sub_nav_bar_shop[selectedItem].menuItems.filter(
      (item: any) => item.label === "Shop All",
    )?.[0]
    return {
      selectedContent: sub_nav_bar_shop[selectedItem].menuItems,
      columns: sub_nav_bar_shop[selectedItem].columns,
      shopAll,
    }
  }, [selectedItem, sub_nav_bar_shop])
  let selectedContent: any = null
  let shopAll: any = null
  let columns = 3
  if (content?.selectedContent) {
    selectedContent = content.selectedContent
    shopAll = content.shopAll
    columns = parseInt(content.columns || "0") || 3
  }
  const { checkout } = useCheckout()

  const searchHandler = (e: any) => {
    e.preventDefault()
    const updatedLocation = location.search.substring(1)
    if (location.search.endsWith("true")) {
      const refParam = location.search.includes("ref")
        ? location.search.substring(location.search.indexOf("ref"))
        : ""
      navigate(`/search?q=${encodeURIComponent(searchValue)}&${refParam}`)
    } else {
      navigate(`/search?q=${encodeURIComponent(searchValue)}`)
    }
  }

  return (
    <div
      style={{ zIndex: selectedItem > -1 ? 999999 : 0 }}
      className="z-[9999] relative"
    >
      <div className="flex relative h-[80px] md:h-[90px] flex-row justify-between items-center bg-white w-full py-3 px-[15px] xl:px-28">
        <div
          className={`flex justify-center md:justify-start relative items-center w-[205px] md:w-[115px] lg:w-[160px] mb-[7px]`}
        >
          <button
            onClick={onMenuClick}
            className="space-y-1.5 mr-5 block md:hidden"
          >
            <div className="w-[32px] h-[3px] bg-[#1C1C1C] rounded-sm"></div>
            <div className="w-[32px] h-[3px] bg-[#1C1C1C] rounded-sm"></div>
            <div className="w-[32px] h-[3px] bg-[#1C1C1C] rounded-sm"></div>
          </button>
          <Link
            to={`/${location.search ? location.search : ""}`}
            className="block"
          >
            <WrittenLogoMark />
          </Link>
        </div>
        {!isSearchExpanded ? (
          <div className="hidden md:flex  items-center space-x-[11px] lg:space-x-6">
            {sub_nav_bar_shop?.map((blok: any, index: number) => {
              return (
                <div
                  onMouseEnter={() => setSelectedItem(index)}
                  className="border-b-4 bg-white border-white hover:border-b-paloverde-light py-4 cursor-pointer"
                >
                  <p className="mb-0 font-extrabold font-condensed text-xs lg:text-[.9rem] uppercase">
                    {blok.title}
                  </p>
                </div>
              )
            })}
          </div>
        ) : (
          <form
            onSubmit={searchHandler}
            className="w-[63%] ml-2 mr-6 my-0 lg:mt-[8px] flex items-center border border-gray-300 rounded-lg"
          >
            <input
              autoFocus
              className="w-full text-xs md:text-[17px] px-4 py-1 md:pt-3 md:pb-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 focus-visible:ring-2 focus-visible:ring-yellow-500 focus-visible:border-yellow-500"
              placeholder="Search..."
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              required
            />
          </form>
        )}
        <SelectedDropDownItem
          selectedContent={selectedContent}
          setSelectedItem={setSelectedItem}
          shopAll={shopAll}
          columns={columns}
        />
        <div className="flex flex-row justify-end items-center space-x-4 mb-[7px]">
          {!isSearchExpanded && (
            <Link
              className="flex md:hidden items-center"
              to={`${
                (
                  typeof window !== "undefined"
                    ? JSON.parse(localStorage.getItem("loggedIn") || "{}")
                    : false
                )
                  ? "/account"
                  : "/welcome"
              }`}
            >
              <FaUserCircle className="w-5 h-5 text-obsidian hover:text-paloverde" />
            </Link>
          )}
          <div className="md:block w-5">
            <button
              className="flex"
              onClick={() => {
                setIsSearchExpanded(!isSearchExpanded)
              }}
            >
              {!isSearchExpanded ? (
                <FaSearch className="w-5 h-5 text-obsidian hover:text-paloverde" />
              ) : (
                <AiOutlineClose className="w-5 h-5 text-obsidian hover:text-paloverde" />
              )}
            </button>
          </div>
          {!isSearchExpanded && (
            <button
              onClick={() => {
                setAddToCartSidebarTypeFunction("basket")
                openAddToCartSidebar()
              }}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="mr-4 md:mr-1">
                  <FaShoppingBasket className="w-6 h-6 text-obsidian hover:text-paloverde" />
                </div>
                <div className="w-5 h-5 ml-[-1rem] flex items-center justify-center pt-[4px] mb-5 text-center hidden md:block font-extrabold text-xs rounded-xl bg-paloverde text-white pt-[1px]">
                  {checkout.lineItems.length}
                </div>
              </div>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default NavBarV2
